import { IDeviceTypes } from '@utils/getDevice';

type AllPaths = [
  'products',
  'updates',
  'onboarding',
  'identificationRequests',
  'configuration',
  'help',
  'tasks',
  'activity',
  'documents',
];

type IPaths = AllPaths[number];
interface IGetEnabledPathsContext {
  isSuperAdmin: boolean;
  deviceType: IDeviceTypes;
}
export function getEnabledPaths(context: IGetEnabledPathsContext): IPaths[] {
  const { isSuperAdmin, deviceType } = context;
  const userMobilePaths: IPaths[] = ['products'];
  if (deviceType === 'mobile') return userMobilePaths;
  const userPaths: IPaths[] = [
    'products',
    'updates',
    'onboarding',
    'configuration',
    'help',
    'activity',
  ];
  const superAdminPaths = [
    'products',
    'updates',
    'onboarding',
    'identificationRequests',
    'configuration',
    'help',
    'tasks',
    'activity',
    'documents',
  ] as AllPaths;

  if (isSuperAdmin) return superAdminPaths;
  return userPaths;
}
